(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (document.documentElement.dataset.faqsBound === 'true') return;
    document.documentElement.dataset.faqsBound = 'true';

    const input = document.querySelector('[data-faqs-search-input]');
    const empty = document.querySelector('[data-faqs-search-empty]');
    const nav = document.querySelector('[data-faqs-nav]');
    const tabs = nav ? nav.querySelectorAll('[data-faqs-tab]') : [];
    let activeCategory = 'all';

    const SYNONYM_GROUPS = [
      ['return', 'returns', 'refund', 'refunds'],
      ['ship', 'shipping', 'delivery', 'deliver'],
      ['bacteria', 'coliform'],
      ['result', 'results', 'report', 'reports'],
    ];

    const synonymLookup = (() => {
      const map = new Map();
      SYNONYM_GROUPS.forEach((group) => {
        group.forEach((word) => map.set(word, group));
      });
      return map;
    })();

    const normalize = (value) =>
      value
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]+/gu, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    const tokens = (value) => normalize(value).split(' ').filter(Boolean);

    const editDistance = (a, b) => {
      if (a === b) return 0;
      if (Math.abs(a.length - b.length) > 1) return 99;
      const rows = a.length + 1;
      const cols = b.length + 1;
      const grid = Array.from({ length: rows }, () => new Array(cols).fill(0));
      for (let i = 0; i < rows; i += 1) grid[i][0] = i;
      for (let j = 0; j < cols; j += 1) grid[0][j] = j;
      for (let i = 1; i < rows; i += 1) {
        for (let j = 1; j < cols; j += 1) {
          const cost = a[i - 1] === b[j - 1] ? 0 : 1;
          grid[i][j] = Math.min(
            grid[i - 1][j] + 1,
            grid[i][j - 1] + 1,
            grid[i - 1][j - 1] + cost
          );
        }
      }
      return grid[a.length][b.length];
    };

    const wordHit = (needle, haystackWords) => {
      if (haystackWords.includes(needle)) return true;

      if (
        needle.length >= 4 &&
        haystackWords.some((word) => {
          const [short, long] = needle.length <= word.length ? [needle, word] : [word, needle];
          return long.startsWith(short) && long.length - short.length <= 3;
        })
      ) {
        return true;
      }

      if (needle.length < 5) return false;
      return haystackWords.some((word) => {
        if (Math.abs(word.length - needle.length) > 1) return false;
        return editDistance(needle, word) <= 1;
      });
    };

    const queryMatches = (query, questionText, answerText) => {
      const normalizedQuery = normalize(query);
      if (!normalizedQuery) return true;

      const question = normalize(questionText || '');
      const answer = normalize(answerText || '');

      if (question.includes(normalizedQuery) || answer.includes(normalizedQuery)) return true;

      const queryWords = tokens(normalizedQuery);
      if (!queryWords.length) return true;

      const questionWords = tokens(question);
      const answerWords = tokens(answer);

      return queryWords.every((word) => {
        const variants = [word, ...(synonymLookup.get(word) || [])].filter(
          (variant, index, list) => list.indexOf(variant) === index
        );
        return variants.some(
          (variant) => wordHit(variant, questionWords) || wordHit(variant, answerWords)
        );
      });
    };

    const setActiveTab = (category) => {
      activeCategory = category || 'all';
      tabs.forEach((tab) => {
        const on = (tab.dataset.faqsTab || 'all') === activeCategory;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };

    const applyFilters = () => {
      const query = input ? input.value.trim().toLowerCase() : '';
      const searching = query.length > 0;
      let visibleCount = 0;

      const sections = [...document.querySelectorAll('.faqs[data-faqs-category]')];
      const evaluations = [];

      sections.forEach((section) => {
        const category = section.dataset.faqsCategory;
        const inCategory = searching || activeCategory === 'all' || category === activeCategory;
        const items = [...section.querySelectorAll('.faqs__item')];

        items.forEach((item) => {
          const question = item.querySelector('.faqs__question')?.textContent || '';
          const answer = item.querySelector('.faqs__answer')?.textContent || '';
          const questionHit = searching && queryMatches(query, question, '');
          const answerHit = searching && !questionHit && queryMatches(query, '', answer);
          const textMatch = !searching || questionHit || answerHit;
          evaluations.push({
            section,
            item,
            inCategory,
            questionHit,
            match: inCategory && textMatch,
          });
        });
      });

      const hasQuestionHits = searching && evaluations.some((entry) => entry.match && entry.questionHit);
      if (hasQuestionHits) {
        evaluations.forEach((entry) => {
          if (entry.match && !entry.questionHit) entry.match = false;
        });
      }

      sections.forEach((section) => {
        const items = evaluations.filter((entry) => entry.section === section);
        let sectionVisible = 0;

        items.forEach((entry) => {
          entry.item.hidden = !entry.match;
          if (entry.match) sectionVisible += 1;
        });

        visibleCount += sectionVisible;

        const categoryEl = section.querySelector('.faqs__category');
        const list = section.querySelector('.faqs__list');
        const inCategory = searching || activeCategory === 'all' || section.dataset.faqsCategory === activeCategory;
        const hideBody = !inCategory || sectionVisible === 0;

        if (categoryEl) categoryEl.hidden = hideBody;
        if (list) list.hidden = hideBody;

        if (section.classList.contains('faqs--category')) {
          section.hidden = hideBody;
        } else {
          section.hidden = false;
        }
      });

      if (empty) empty.hidden = visibleCount > 0;
      if (nav) nav.hidden = searching;

      requestAnimationFrame(() => {
        window.ScrollTrigger?.refresh();
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (input) input.value = '';
        setActiveTab(tab.dataset.faqsTab || 'all');
        applyFilters();
      });
    });

    if (input) {
      input.addEventListener('input', () => {
        if (input.value.trim()) setActiveTab('all');
        applyFilters();
      });
      input.addEventListener('search', () => {
        if (input.value.trim()) setActiveTab('all');
        applyFilters();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testing-made-simple"] && !Shopify.designMode) return;
  try {
    
  class TmsVideoPlayer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.video = this.querySelector('video');
      this.playBtn = this.querySelector('[data-tms-play]');
      this.muteBtn = this.querySelector('[data-tms-mute]');
      this.hint = this.querySelector('[data-tms-hint]');

      if (!this.video) return;

      this.video.muted = true;
      this.video.controls = false;
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');

      this.playBtn?.addEventListener('click', () => this.start({ unmute: true }));
      this.muteBtn?.addEventListener('click', () => this.start({ unmute: true }));
      this.hint?.addEventListener('click', () => this.start({ unmute: true }));
      this.addEventListener('click', (event) => this.onPlayerTap(event));
      this.video.addEventListener('ended', () => this.reset());
    }

    onPlayerTap(event) {
      if (event.target.closest('[data-tms-play], [data-tms-mute], [data-tms-hint]')) return;
      if (this.classList.contains('is-playing')) return;
      this.start({ unmute: true });
    }

    async start({ unmute = false } = {}) {
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('webkit-playsinline', '');
      this.video.controls = true;
      this.classList.add('is-playing');

      if (unmute) {
        this.video.defaultMuted = false;
        this.video.muted = false;
        this.video.removeAttribute('muted');
        this.video.volume = 1;
      }

      try {
        await this.video.play();
        if (unmute && this.video.muted) {
          this.video.muted = false;
          this.video.removeAttribute('muted');
        }
      } catch (e) {
        this.video.muted = true;
        try {
          await this.video.play();
        } catch (err) {
          this.video.controls = false;
          this.classList.remove('is-playing');
        }
      }
    }

    reset() {
      this.video.pause();
      this.video.currentTime = 0;
      this.video.muted = true;
      this.video.controls = false;
      this.classList.remove('is-playing');
    }
  }

  if (!customElements.get('tms-video-player')) {
    customElements.define('tms-video-player', TmsVideoPlayer);
  }

  } catch(e) { console.error(e); }
})();
})();
